import React from "react";
import "./TableWorker.styles.scss";
import "../ManageModal/CreateModal.styles.scss";
import axios from "axios";
import { Button } from "react-materialize";
import MDOManageModal from "../MDOManageModal/MDOManageModal";
import InfoDrawer from "../InfoDrawer/InfoDrawer";
import ManageModal from "../ManageModal/ManageModal";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import EscapeOutside from "react-escape-outside";
import BounceLoader from "react-spinners/BounceLoader";
import { IconButton } from "@material-ui/core";

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={handleClose}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  );
};

class TableWorker extends React.Component {
  constructor() {
    super();

    this.state = {
      showMDOManageModal: false,
      showCreateModal: false,
      reset: true,
      showDeleteConfirm: false,
      deleting: false,
    };
  }

  showCreateModal = () => this.setState({ showCreateModal: true });
  hideCreateModal = () => this.setState({ showCreateModal: false });

  deleteSpot = () => {
    this.setState({ deleting: true });
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/spots`,

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          data: { code: this.props.data["code"] },
        }
      )
      .then((res) => {
        alert("Successfully deleted spot");
        console.log("success");

        this.setState({ showDeleteConfirm: false, deleting: false });
        this.props.handleDelete();
      })
      .catch((err) => {
        console.log(err);
        this.setState({ showDeleteConfirm: false, deleting: false });
      });
  };

  render() {
    const {
      code,
      name,
      division,
      district,
      agency__name,
      agency__id,
      user_tag,
      ma_wallet,
    } = this.props.data;

    return (
      <tr className="worker-row">
        <td className="emp-id">
          <span>
            {this.props.selectedZoneMember["id"] === "agency"
              ? this.props.data["code"]
              : this.props.data["id"]}
          </span>
        </td>
        <td className="phone">
          <span>{name}</span>
        </td>
        <td className="agency">
          <span>
            {this.props.selectedZoneMember["id"] === "regions" ||
            this.props.selectedZoneMember["id"] === "clusters"
              ? this.props.data["division"]
              : this.props.data["district"]}
          </span>
        </td>

        {this.props.selectedZoneMember["id"] === "agency" && (
          <td className="agency">
            <span>
              {this.props.data["thana"] === ""
                ? "n/a"
                : this.props.data["thana"]}
            </span>
          </td>
        )}

        {this.props.selectedZoneMember["parent"] && (
          <td className="agency">
            <span>
              {this.props.data[this.props.selectedZoneMember["parent"]]}
            </span>
          </td>
        )}

        {this.props.selectedZoneMember["children"] && (
          <td className="leave">
            <span>
              {/* {
                this.props.data[this.props.selectedZoneMember["children"]]
                  .length
              }{" "}
              {this.props.selectedZoneMember["children"]} */}
              <InfoDrawer
                data={
                  this.props.data[this.props.selectedZoneMember["children"]]
                }
                member={this.props.selectedZoneMember}
                heading={
                  this.props.data[this.props.selectedZoneMember["children"]]
                    .length +
                  " " +
                  this.props.selectedZoneMember["children"]
                }
              />
            </span>
          </td>
        )}

        {this.props.selectedZoneMember["id"] === "agency" && (
          <td>
            {ma_wallet && ma_wallet !== "" ? (
              ma_wallet
            ) : (
              <b style={{ fontWeight: 300, opacity: 0.3, color: "red" }}>N/A</b>
            )}
          </td>
        )}

        <td className="button-column">
          <ManageModal
            handleHide={this.hideCreateModal}
            show={this.state.showCreateModal}
            reset={this.state.reset}
            selectedZone={this.props.selectedZoneMember}
            data={this.props.data}
            zoneMapping={this.props.zoneMapping}
          />
          <div className="button-wrapper">
            <Button
              className="button"
              onClick={() => {
                this.showCreateModal();
              }}
            >
              Manage
            </Button>
            {/* <MDOManageModal
              handleHide={this.hideMDOManageModal}
              show={this.state.showMDOManageModal}
              data={this.props.data}
              handleSave={this.props.handleSave}
            /> */}
            <Modal
              show={this.state.showDeleteConfirm}
              handleClose={() => this.setState({ showDeleteConfirm: false })}
            >
              <div className="modal-header">
                <div className="headline">
                  <div className="main-headline">
                    Delete Spot {this.props.data["code"]}
                  </div>
                  <div className="sub-headline"></div>
                </div>
              </div>
              <div className="modal-body">
                Are you sure want to delete spot {this.props.data["code"]} ?
              </div>
              <div className="footer">
                <BounceLoader
                  className="loader"
                  color={"#e2136e"}
                  size={20}
                  loading={this.state.deleting}
                />

                <button
                  className="button--cancel"
                  onClick={() => this.setState({ showDeleteConfirm: false })}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button className="button--save" onClick={this.deleteSpot}>
                  {this.state.deleting ? "Deleting" : "Yes"}
                </button>
              </div>
            </Modal>
            {this.props.selectedZoneMember["id"] === "spots" && (
              <div className="delete-container">
                <IconButton
                  onClick={() => this.setState({ showDeleteConfirm: true })}
                  style={{ border: "1px solid #e2136e" }}
                  size={"small"}
                >
                  <DeleteForeverIcon className="delete-icon" />
                </IconButton>
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  }
}

export default TableWorker;
